<div class="flex-column justify-content-center align-items-center h-100vh banner v4-bg-img">
    <!-- <div #air id="air" class='air'></div> -->
    <div class="v4-login-card p-4 w-full lg:w-6">
        <div class="text-center mb-5">
            <img src="../../../assets/v-4-icone/Vector.png" alt="Image" height="50" class="mb-3">
        </div>
        <h3 class="sstarabicbold text-center v4-color-white pb-2">{{"Password Reset" | translator}}</h3>
        <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()" dir="rtl" [style.fontSize.px]="12">
            <div class="form-group clearfix" [ngClass]="{ 'has-error': submitted }">

                <label class="ms-label-view"> {{"Current password" | translator}}</label>
                <div class="d-flex-item-center">
                    <input [type]="hide3 ? 'password' : 'text'" formControlName="oldPassword"
                        placeholder='{{"Current password" | translator}}' pInputText class="w-full mb-3 text-start ms-input-view ms-border">
                    <div *ngIf="hide3; else elseBlock3"> <i (click)="hide3 = !hide3"
                            class="fa-regular fa-eye-slash font-1rem mx-2 v4-color-white"></i></div>
                    <ng-template #elseBlock3><i (click)="hide3 = !hide3"
                            class="fa-regular fa-eye font-1rem mx-2 v4-color-white"></i></ng-template>
                </div>

                <label class="font-12 ms-label-view">{{"New Password" | translator}}</label>
                <div class="d-flex-item-center">
                    <input [type]="hide ? 'password' : 'text'" formControlName="password"
                        [(ngModel)]="password1" placeholder='{{"New Password" | translator}}' pInputText class="w-full mb-3 text-start ms-input-view ms-border">
                    <div *ngIf="hide; else elseBlock"> <i (click)="hide = !hide"
                            class="fa-regular fa-eye-slash font-1rem mx-2 v4-color-white"></i></div>
                    <ng-template #elseBlock><i (click)="hide = !hide"
                            class="fa-regular fa-eye font-1rem mx-2 v4-color-white"></i></ng-template>
                </div>


            </div>
            <div class="form-group clearfix" [ngClass]="{ 'has-error': submitted }">

                <label class="font-12 ms-label-view">{{"Confirm the new password" | translator}}</label>
                <div class="d-flex-item-center">
                    <input [type]="hide2 ? 'password' : 'text'" formControlName="conformPassword"
                        [(ngModel)]="password2" placeholder='{{"Confirm the new password" | translator}}' pInputText class="w-full mb-3 text-start ms-input-view ms-border">
                    <div *ngIf="hide2; else elseBlock2"> <i (click)="hide2 = !hide2"
                            class="fa-regular fa-eye-slash font-1rem mx-2 v4-color-white"></i></div>
                    <ng-template #elseBlock2><i (click)="hide2 = !hide2"
                            class="fa-regular fa-eye font-1rem mx-2 v4-color-white"></i></ng-template>
                </div>


                <div dir="rtl" class="row mb-2 text-end px-2">
                    <h6 class="text-center v4-color-white">{{"Password creation requirements" | translator}}</h6>
                    <div class="col-4 text-start" [ngClass]=" checkpassword() ? 'text-success' : 'text-danger'">
                        <i [hidden]="checkpassword()" class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!checkpassword()" class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"Password match" | translator}}
                    </div>

                    <div class="col-4 text-start" [ngClass]=" atleast8() ? 'text-success' : 'text-danger'">
                        <i [hidden]="atleast8()" class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!atleast8()" class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"At least 8 characters" | translator}}
                    </div>

                    <div class="col-4 text-start" [ngClass]=" atleastcapital() ? 'text-success' : 'text-danger'">
                        <i [hidden]="atleastcapital() " class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!atleastcapital() " class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"One uppercase letter (at least)" | translator}}
                    </div>

                    <div class="col-4 text-start" [ngClass]=" atleastsmall() ? 'text-success' : 'text-danger'">
                        <i [hidden]="atleastsmall() " class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!atleastsmall() " class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"One lowercase letter (at least)" | translator}}
                    </div>

                    <div class="col-4 text-start" [ngClass]=" atleastnumber() ? 'text-success' : 'text-danger'">
                        <i [hidden]="atleastnumber() " class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!atleastnumber() " class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"One number (at least)" | translator}}
                    </div>

                    <div class="col-4 text-start" [ngClass]=" atleastspecial() ? 'text-success' : 'text-danger'">
                        <i [hidden]="atleastspecial() " class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!atleastspecial() " class="fa fa-check-circle" aria-hidden="true"></i>

                        {{"One special code (at least)" | translator}}
                    </div>
                </div>


            </div>

            <p *ngIf="message" style="color: red;" class="text-center error"> {{message}}</p>

            <div class="col-xs-12 form-group text-right">
                <button type="submit" pButton pRipple  label='{{"OK" | translator}}'  icon="pi pi-key" class="w-full v4-login-btn"></button>
            </div>
        </form>
    </div>
    <div class="text-center pt-3 ">
        <!-- <span class="white">{{"Do you want to reset your password?" | translator}}</span>
        &nbsp;&nbsp; -->

        <span (click)="redirectHome()" class="bottom-btns2">
            {{"If you do not want to reset your password, you can click here to return to the home page" | translator}}
        </span>
    </div>
</div>
